// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__j2yFs","placeholdersHeader":"styles_placeholdersHeader__32MGH","editorStyle":"styles_editorStyle__1KBrO","placeholdersBox":"styles_placeholdersBox__Koa_h"};